import { useSubscription } from '@apollo/client'
import { notification } from 'antd'
import { get, isEmpty, some } from 'lodash'

import { useTabFocus } from '../../core/hooks'
import { areSameValue } from '../../core/utils'

import { METADATA_TYPES } from '../constants'
import { UPDATED_METADATA_SUBSCRIPTION } from '../graphql/subscriptions'
import { apolloService } from '../services'

import useLoggedInUser from './use-logged-in-user'

const useUpdatedIngredientSubscription = (
  id,
  isDirty,
  metadataType,
  refetch,
) => {
  const isTabFocused = useTabFocus()
  const { id: currentLoggedInUser } = useLoggedInUser()

  useSubscription(UPDATED_METADATA_SUBSCRIPTION, {
    fetchPolicy: 'no-cache',
    client: apolloService.client.client,
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (isEmpty(data)) {
        return
      }

      const { metadataUpdated } = data

      const metadataTypeField = get(METADATA_TYPES, `${metadataType}.key`)
      const metadataIds = get(metadataUpdated, metadataTypeField)

      const updatedByUserId = get(metadataUpdated, 'updatedByUserId')

      if (!some(metadataIds, metadataId => areSameValue(metadataId, id))) {
        return
      }

      if (isTabFocused) {
        return
      }

      if (!isDirty) {
        refetch(id)
        return
      }

      const shouldNotifyLoggedInUser = areSameValue(
        updatedByUserId,
        currentLoggedInUser,
      )

      if (shouldNotifyLoggedInUser) {
        return
      }

      notification.error({
        message: 'Could not refresh page.',
        description:
          'The page was updated and could not refresh due to changes. Please discard your changes and refresh the page to not lose data.',
        placement: 'topLeft',
        duration: 0,
      })
    },
  })
}

export default useUpdatedIngredientSubscription
